import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { ValidityListComponent } from './validity-list/validity-list.component'

export const validityRoutes: Route[] = [
  {
    path: 'validities',
    component: ValidityListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'validities/:id/edit',
    redirectTo: 'validities/:id',
    pathMatch: 'full'
  },
  {
    path: 'validities/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Validity',
        nameSingular: 'Validity',
        namePlural: 'Validities',
        path: 'validities',
        slug: 'taxonomies/validities',
        title: 'Validities'
      }),
      permission: 'readTaxonomies'
    }
  }
]
